import { DatePickerProps as AntDatePickerProps, DatePicker } from 'antd'

export type DatePickerProps = AntDatePickerProps

export default DatePicker.RangePicker
